import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const RegionalOnboardingCardId = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleContinue = () => {
    const currentParams = location.search;
    navigate(`/regional-onboarding_welcome-corporativo-mobile${currentParams}`);
  };

  const handleBack = () => {
    const currentParams = location.search;
    navigate(`/regional-onboarding_phone-corporativo-mobile${currentParams}`);
  };

  return (
    <div className="regional-card-id">
      <div className="regional-card-id-container">
        {/* Dot Pattern Background */}
        <div className="card-id-dot-pattern">
          <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
            {[...Array(8)].map((_, row) =>
              [...Array(8)].map((_, col) => {
                const opacity = 0.1 + (row * 0.05) + (col * 0.03);
                return (
                  <circle
                    key={`${row}-${col}`}
                    cx={20 + col * 25}
                    cy={20 + row * 25}
                    r="3"
                    fill={colors.secundario}
                    fillOpacity={Math.min(opacity, 0.8)}
                  />
                );
              })
            )}
          </svg>
        </div>

        {/* Header */}
        <div className="card-id-header">
          <div className="back-button" onClick={handleBack}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke={colors.primario} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div className="step-indicator">Step  of 8</div>
        </div>

        {/* Title Section */}
        <div className="card-id-title-section">
          <h1 className="card-id-title">Let's verify your identity</h1>
          <p className="card-id-subtitle">
            This step ensures your account is secure and accessible only to you.
          </p>
        </div>

        {/* ID Card Illustration */}
        <div className="card-id-illustration">
          <div className="id-card-visual">
            <div className="id-card-front">
              <div className="id-card-photo">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="20" cy="16" r="8" fill="#9CA3AF"/>
                  <path d="M4 36C4 28.268 10.268 22 18 22H22C29.732 22 36 28.268 36 36V40H4V36Z" fill="#9CA3AF"/>
                </svg>
              </div>
              <div className="id-card-lines">
                <div className="id-line"></div>
                <div className="id-line short"></div>
                <div className="id-line"></div>
              </div>
            </div>
            <div className="id-card-back">
              <div className="sparkles">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L14.09 8.26L20 9.27L15.55 13.14L16.91 19.02L12 16.27L7.09 19.02L8.45 13.14L4 9.27L9.91 8.26L12 2Z" fill="#87CEEB"/>
                </svg>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L14.09 8.26L20 9.27L15.55 13.14L16.91 19.02L12 16.27L7.09 19.02L8.45 13.14L4 9.27L9.91 8.26L12 2Z" fill="#87CEEB"/>
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* Instructions List */}
        <div className="card-id-instructions">
          <div className="instruction-item">
            <div className="instruction-icon" style={{ color: colors.primario }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="2"/>
                <path d="M4 20C4 16.6863 6.68629 14 10 14H14C17.3137 14 20 16.6863 20 20V21H4V20Z" stroke="currentColor" strokeWidth="2"/>
              </svg>
            </div>
            <p className="instruction-text">Remove any glasses or accessories and keep a neutral face.</p>
          </div>
          <div className="instruction-item">
            <div className="instruction-icon" style={{ color: colors.primario }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
                <path d="M12 2V4M12 20V22M2 12H4M20 12H22M4.93 4.93L6.34 6.34M17.66 17.66L19.07 19.07M4.93 19.07L6.34 17.66M17.66 6.34L19.07 4.93" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </div>
            <p className="instruction-text">Find a spot with good lighting.</p>
          </div>
          <div className="instruction-item">
            <div className="instruction-icon" style={{ color: colors.primario }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="2"/>
                <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
              </svg>
            </div>
            <p className="instruction-text">This process is secure and used solely to confirm your identity.</p>
          </div>
        </div>

        {/* Action Button */}
        <div className="card-id-actions">
          <button
            className="btn-continue"
            style={{ backgroundColor: colors.primario }}
            onClick={handleContinue}
          >
            Continue
          </button>
        </div>

        {/* Bottom Dot Pattern */}
        <div className="card-id-dot-pattern-bottom">
          <svg width="200" height="100" viewBox="0 0 200 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            {[...Array(4)].map((_, row) =>
              [...Array(8)].map((_, col) => {
                const opacity = 0.3 - (row * 0.05);
                return (
                  <circle
                    key={`bottom-${row}-${col}`}
                    cx={20 + col * 25}
                    cy={20 + row * 25}
                    r="3"
                    fill={colors.primario}
                    fillOpacity={Math.max(opacity, 0.1)}
                  />
                );
              })
            )}
          </svg>
        </div>
      </div>
    </div>
  );
};
